export default '4.23.4';
